/**
 * Safely parses JSON from localStorage
 * @param {string} key - The localStorage key
 * @param {any} defaultValue - Default value if parsing fails or key doesn't exist
 * @returns {any} Parsed value or default value
 */
export const getFromLocalStorage = (key, defaultValue = null) => {
  try {
    const item = localStorage.getItem(key);
    if (item === null || item === undefined || item === "undefined") {
      return defaultValue;
    }
    return JSON.parse(item);
  } catch (error) {
    console.warn(`Failed to parse localStorage key "${key}":`, error);
    return defaultValue;
  }
};

/**
 * Safely sets JSON to localStorage
 * @param {string} key - The localStorage key
 * @param {any} value - The value to store
 */
export const setToLocalStorage = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(`Failed to set localStorage key "${key}":`, error);
  }
};

/**
 * Safely removes item from localStorage
 * @param {string} key - The localStorage key to remove
 */
export const removeFromLocalStorage = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`Failed to remove localStorage key "${key}":`, error);
  }
};

/**
 * Get user from localStorage safely
 * @returns {object|null} User object or null
 */
export const getUserFromLocalStorage = () => {
  return getFromLocalStorage("user", null);
};
